import React from "react";
import { useLocation } from "react-router-dom";
import { User, Settings, ChevronRight } from "react-feather";
import { Link } from "react-router-dom";
import wallet from "../../../component/img/wallet.png";


const BreadCrumb = () => {
  const location = useLocation(); // Get the current location

  // Determine breadcrumb labels based on the path
  const getBreadcrumbLabel = (path) => {
    switch (path) {
      case "/admin-dashboard":
        return "Admin Dashboard";
      case "/booking-enquiry":
        return "Booking Enquiry";
      case "/user-agents":
        return "Users/ Agents/ Distributor";
      case "/admin-packages":
        return "All Packages";

        case "/admin-profile":
        return "My Profile";

        case "/social-links":
        return "Social Media Links";

        case "/admin-booking":
        return "All Bookings";

        case "/all-staff":
        return "All Staff /Employee";

        case "/admin-booking-report":
        return "Booking Report";

        case "/admin-booking-report":
        return "Booking Report";

        case "/admin-change-password":
        return "Change Password";

        

      default:
        return "Dashboard";
    }
  };
  
  // Current page label based on the path
  const currentLabel = getBreadcrumbLabel(location.pathname);

  return (
    <>
      {/* Top Bar */}
      <div className="bg-white sticky-top topbar1 ">
        <div className="row">
          <div className="col-6"></div>
          <div className="col-6">
            <ul className="d-flex justify-content-end">
               
              {/* <li className="mx-2 op1">
                <Link to="/admin-profile" className="op1 walletadm">
                <img src={wallet} className="img-fluid waletimg" />
                500.00
                </Link>
                
              </li> */}

              <li className="mx-2 op1">
                <Link to="/admin-profile" className="op1">
                <User size={16} />
                &nbsp;User Name
                </Link>
                
              </li>

            </ul>
          </div>
        </div>
      </div>

      {/* Breadcrumb Section */}
      <div className="px-2 text-start brdcrm1 my-2">
        <span className="brdcrm1">Dashboard</span>
        <span>&nbsp;<ChevronRight size={15} />&nbsp;</span>
        <span className="brdcrm1">{currentLabel}</span>
      </div>
    </>
  );
};

export default BreadCrumb;
